import React, { Component } from 'react';
import "./Resume.css";

class EchoStar extends Component {
    render() {
        return (
            <div className="EchoStar">
                            <h1 className="text-center section-heading">EchoStar 12/12 - 10/16</h1>
                            <hr/>
                            <p>In addition to fixing bugs discovered in legacy software, my tasks at EchoStart included:</p>
                            <ul>
                                <li>Time keeping functions for the SAGE product including configuring the open source
                                    busybox implementation to have network time protocol daemon functionality, creating
                                    time zone binary files including special custom time zone binaries for testing, and
                                providing system interface APIs related to time keeping.</li>

                                <li>Creating middle level APIs for the HDMI repeater functionality of the SAGE product
                                    and subsequently attending CTA/CEA Plugfest 20, 21, and 22 to test SAGE's HDMI
                                interoperability.</li>

                            </ul>
                        </div>
        );
    }
} 

export default EchoStar;





// WEBPACK FOOTER //
// ./src/components/Resume/EchoStar.js